import {immute} from "services-comun/modules/utiles/object";

import {DominioTiempo} from "../";

const tiempo_br = immute(new DominioTiempo({ dominio: "tempo.com", id: "br", pais: 82,  idiomas: ["pt-BR"], }));

export default tiempo_br;
